import { currentBreakpoint } from '@otto-ec/global-resources/viewport';
import type { SelectionPage, SelectionResult } from '@otto-ec/nexus-registry/selection';
import type { Page } from '@shared/types/Tilelist.ts';
import type { EventsOutgoing } from '@tilelist/application/ports/EventsOutgoing.ts';

export function publishLegacyResolution(eventsOutgoing: EventsOutgoing, result: SelectionResult, ssid: string): void {
    const breakpoint = currentBreakpoint.get();

    eventsOutgoing.publishPageResolution({
        mergeOnPi: true,
        shouldScroll: breakpoint === 's' || breakpoint === 'm',
        rule: result.selection.rule,
        page: legacyPage(result.selection.page),
        redirect: result.selection.url,
        entryRule: result.selection.entryRule,
        ...(result.count !== undefined ? { count: result.count } : {}),
        ssid,
    });
}

function legacyPage(page: SelectionPage): Page {
    return {
        ...(page.layout !== undefined ? { l: page.layout } : {}),
        ...(page.offset !== undefined ? { o: page.offset } : {}),
        ...(page.sortOrder !== undefined ? { sortiertnach: page.sortOrder } : {}),
    };
}
